export const isPregnancyAndBreastfeedingPage = (pathname) => {
  return (
    pathname.includes("/Pregnancy_and_Breastfeeding") ||
    pathname.includes("/quicklinks")
  );
};
